module.exports = __webpack_public_path__ + "img/meme_26.d98355d8.jpg";